import { Modal } from "./types";

const defaultModal = {
    component: null,
    options: {
        title: "",
        width: null,
        height: null,
        large: false,
        small: false,
        padding0: false,
        wide: false,
        long: false,
        ignoreClickOutside: false,
        onClose: null,
        overlay: null,
        modalType: null,
        customProps: null,
    },
};

const initialState = {
    modalStack: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Modal.OPEN:
            return {
                ...state,
                modalStack: [
                    ...state.modalStack,
                    {
                        isOpen: true,
                        component: action.component,
                        options: {
                            ...defaultModal.options,
                            ...action.options,
                        },
                    },
                ],
            };

        case Modal.CLOSE:
            const newStack = state.modalStack.slice(0, -1);
            return {
                ...state,
                modalStack: newStack.length > 0 ? newStack : [],
            };

        case Modal.CLOSE_ALL:
            return {
                ...state,
                modalStack: [],
            };

        case Modal.UPDATE:
            const updatedStack = state.modalStack.map((modal, index) => {
                if (index === state.modalStack.length - 1) {
                    return {
                        ...modal,
                        options: { ...modal.options, ...action.options },
                    };
                }
                return modal;
            });

            return {
                ...state,
                modalStack: updatedStack,
            };

        default:
            return state;
    }
};
